// query yang nentuin sub-halaman, sisanya filter yang bikin laporan GA pecah
const PAGE_QUERY_KEYS = ['menu', 'tab'];
// batas panjang nilai user property GA4
const MAX_PROPERTY_LENGTH = 36;
// biar hash email gak bisa dicocokin ke daftar hash email umum
const USER_ID_SALT = 'mantraz-ga:';

/**
 * Halaman versi GA: pola route (tanpa id) + query tab, filter dibuang.
 * @returns {{ path: string, title: string }}
 */
export function pageFromRoute(route) {
  const record = route.matched[route.matched.length - 1];
  const path = record ? record.path : route.path;
  const title = route.name || path;
  const key = PAGE_QUERY_KEYS.find((k) => route.query[k]);
  if (!key) return { path, title };
  return { path: `${path}?${key}=${route.query[key]}`, title: `${title} / ${route.query[key]}` };
}

function clip(value) {
  return value ? String(value).slice(0, MAX_PROPERTY_LENGTH) : undefined;
}

/** User property GA (role, company, app) dari state auth. */
export function userProperties({ roles = [], activeCompany, activeApp }) {
  return {
    user_role: clip(roles.map((role) => role.roleName).sort().join(', ')),
    company: clip(activeCompany?.compName),
    app: clip(activeApp?.name),
  };
}

/**
 * userId dari /status itu email, GA ngelarang PII jadi dikirim versi hash-nya.
 * @returns {Promise<string|undefined>} hex SHA-256, undefined kalau gak ada userId / bukan secure context
 */
export async function hashUserId(userId) {
  if (!userId || typeof crypto === 'undefined' || !crypto.subtle) return undefined;
  const bytes = new TextEncoder().encode(`${USER_ID_SALT}${userId}`);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
}

export function initAnalytics(measurementId) {
  if (!measurementId) return;
  window.dataLayer = window.dataLayer || [];
  // gtag wajib push `arguments`, bukan array biasa
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
}

let lastPath;

export async function trackPageView(route, authState) {
  if (!window.gtag) return;
  const page = pageFromRoute(route);
  // ganti filter doang = halaman sama
  if (page.path === lastPath) return;
  lastPath = page.path;

  window.gtag('set', { user_id: await hashUserId(authState.userId) });
  window.gtag('set', 'user_properties', userProperties(authState));
  window.gtag('event', 'page_view', {
    page_title: page.title,
    page_location: `${window.location.origin}${page.path}`,
  });
}
